import { AuthSelectors } from '@/app/+state/auth';
import { selectIsLoggedIn } from '@/app/+state/auth/auth.selectors';
import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

export const publicGuard: CanActivateFn = () => {
    const store = inject(Store);
    const router = inject(Router);

    return store.select(AuthSelectors.selectAuthInitialized).pipe(
        filter((initialized) => initialized),
        take(1),
        switchMap(() => combineLatest([store.select(selectIsLoggedIn)])),
        take(1),
        map(([isLoggedIn]) => {
            if (!isLoggedIn) {
                return true;
            }
            return router.createUrlTree(['/']);
        }),
    );
};
